import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./OperationalPannel.css";

const OperationsPanel = ({
  orders,
  selectedStatus,
  setSelectedStatus,
  selectedTime,
  setSelectedTime,
  searchTerm,
  setSearchTerm
}) => {

  const navigate = useNavigate();

  const statusCounts = useMemo(() => {
    const counts = {};
    orders.forEach((order) => {
      counts[order.status] = (counts[order.status] || 0) + 1;
    });
    return counts;
  }, [orders]);

  const timeFilters = [
    { label: "30 min", value: "30" },
    { label: "1 hour", value: "60" },
    { label: "Today", value: "ALL" }
  ];

  return (
    <div className="ops-panel-wrapper">

      {/* TIME FILTERS */}
      <div className="ops-time-section">
        {timeFilters.map((time) => (
          <button
            key={time.value}
            className={`ops-time-btn ${
              selectedTime === time.value ? "ops-time-active" : ""
            }`}
            onClick={() => setSelectedTime(time.value)}
          >
            {time.label}
          </button>
        ))}
      </div>

      {/* MANAGE ITEMS BUTTON */}
    

      {/* SEARCH */}
      <input
        className="ops-search-input"
        placeholder="Search by Table No / Customer / Phone"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* STATUS FILTER */}
      <select
        className="ops-status-dropdown"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="ALL">All Status</option>
        <option value="PENDING">PENDING</option>
        <option value="PREPARING">PREPARING</option>
        <option value="READY">READY</option>
        <option value="CONFIRMED">CONFIRMED</option>
        <option value="SERVED">SERVED</option>
        <option value="CANCELLED">CANCELLED</option>
      </select>

      {/* BADGES */}
      <span className="ops-badge pending">
        PENDING: {statusCounts["PENDING"] || 0}
      </span>

      <span className="ops-badge preparing">
        PREPARING: {statusCounts["PREPARING"] || 0}
      </span>

      <span className="ops-badge ready">
        READY: {statusCounts["READY"] || 0}
      </span>

        <button
        className="ops-manage-btn"
        onClick={() => navigate("/kanchi-category")}
      >
        Manage Items
      </button>

        <button
        className="ops-manage-btn"
        onClick={() => navigate("/reports")}
      >
        Reports Page
      </button>
      
    </div>
  );
};

export default OperationsPanel;